import * as style from './style.css';
import { Avatar, Overline, UIHeading4, LinkButton, useDeviceType, Responsive, UIText3 } from '@cian/ui-kit';
import { IBuilder } from '../../types/layouts/builder';
import React, { useMemo } from 'react';
import { trackClickLayoutsSeoLink } from '../../utils/tracking/trackSeoLayoutPageLinkClick';
import { trackBuilderCardLinkClick } from '../../utils/tracking/trackBuilderCardLinkClick';

interface IBuilderProps {
  builders: IBuilder[];
  newbuildingId: number;
}

export const Builder = ({ builders, newbuildingId }: IBuilderProps): React.JSX.Element | null => {
  const device = useDeviceType();

  const builder = useMemo(() => builders[0], [builders]);

  const avatarSize = useMemo(() => (device === 'desktop' ? 64 : 40), [device]);

  const onLinkClick = React.useCallback(
    () =>
      trackClickLayoutsSeoLink({
        newbuildingId,
        withRoomFilter: false,
      }),
    [],
  );

  if (!builder) {
    return null;
  }

  return (
    <div className={style['container']}>
      <a
        className={style['builder-avatar-link']}
        href={builder.url}
        target="_blank"
        rel="noreferrer"
        onClick={trackBuilderCardLinkClick}
      >
        <Avatar size={avatarSize} type="builder" src={builder.logoUrl} />
      </a>
      <div className={style['builder-name']}>
        <Responsive desktop>
          <Overline color="gray60_100">Застройщик</Overline>
        </Responsive>
        <a
          className={style['builder-name-link']}
          href={builder.url}
          target="_blank"
          rel="noreferrer"
          onClick={trackBuilderCardLinkClick}
        >
          <UIHeading4 as="span">{builder.name}</UIHeading4>
        </a>
        <Responsive tablet phone>
          <UIText3 color="gray60_100">Застройщик</UIText3>
        </Responsive>
      </div>
      <Responsive desktop>
        <div className={style['button']}>
          <LinkButton
            size="XS"
            theme="fill_primary"
            href={builder.layoutsUrl}
            fullWidth
            target="_blank"
            onClick={onLinkClick}
          >
            Все планировки
          </LinkButton>
        </div>
      </Responsive>
    </div>
  );
};
